import { AppBar, CircularProgress, Toolbar, Typography } from '@mui/material'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import * as React from 'react'

interface IResponsiveAppBarProps {
  title: React.ReactNode
  pageIcon?: React.ReactElement<SvgIconProps>
  isLoading?: boolean
  isModal?: boolean
  children?: React.ReactNode
}

const ResponsiveAppBar: React.FC<IResponsiveAppBarProps> = ({
  children,
  title,
  pageIcon,
  isModal,
  isLoading = false,
}) => {
  const appBarStyle = {
    boxShadow: 'none',
    pageIcon,
    width: '100%',
    borderRadius: isModal ? '4px 4px 0px 0px' : 'default',
  }

  return (
    <div
      style={{
        marginBottom:
          process.env.REACT_APP_ENVIRONMENT !== '' && !(isModal ?? false)
            ? '20px'
            : '0px',
      }}
    >
      <AppBar
        style={appBarStyle}
        position="sticky"
        sx={{
          height: '65px',
          paddingTop: '7px',
        }}
      >
        <Toolbar variant="dense">
          {pageIcon && (
            <SvgIcon color="inherit" style={{ fontSize: 24, marginRight: 8 }}>
              {pageIcon}
            </SvgIcon>
          )}
          <Typography
            variant="h6"
            color="inherit"
            sx={{
              flexGrow: 1,
              fontSize: '22.5px',
            }}
          >
            {title}
            {isLoading ? (
              <CircularProgress style={{ marginLeft: 20 }} size={16} />
            ) : (
              <></>
            )}
          </Typography>
          <div>{children}</div>
        </Toolbar>
        {process.env.REACT_APP_ENVIRONMENT != '' && !(isModal ?? false) && (
          <Toolbar
            style={{
              backgroundColor: 'darkred',
              color: 'white',
              height: '30px',
              minHeight: '30px',
              textAlign: 'center',
              marginBottom: '10px',
            }}
          >
            <Typography variant="h6" color="inherit" style={{ width: '100%' }}>
              {process.env.REACT_APP_ENVIRONMENT}
            </Typography>
          </Toolbar>
        )}
      </AppBar>
    </div>
  )
}

export default ResponsiveAppBar
